import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState('home');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
      let current = 'home';
      navLinks.forEach((link) => {
        const el = document.getElementById(link.id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = link.id;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleJump = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({ top: el.offsetTop - 72, behavior: 'smooth' });
    }
  };

  const textColor = scrolled ? 'text-foreground-800' : 'text-background-50';
  const brandColor = scrolled ? 'text-foreground-950' : 'text-background-50';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full flex items-center justify-between px-4 md:px-8 h-16 md:h-[72px]">
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            handleJump('home');
          }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-lg ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-flashlight-fill text-lg"></i>
          </span>
          <span className={`font-heading text-lg font-bold tracking-wide ${brandColor}`}>
            爆料看点
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleJump(link.id);
                }}
                className={`px-3.5 py-2 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  active === link.id
                    ? scrolled
                      ? 'text-primary-600 font-medium'
                      : 'text-background-50 font-medium'
                    : `${textColor} hover:text-primary-500`
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              handleJump('contact');
            }}
            className="px-4 py-2 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            投递线索
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? 'text-foreground-900' : 'text-background-50'
          }`}
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <ul className="flex flex-col">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleJump(link.id);
                  }}
                  className="block px-2 py-3 text-sm text-foreground-800 border-b border-background-100 cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              handleJump('contact');
            }}
            className="mt-3 block text-center px-4 py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 cursor-pointer whitespace-nowrap"
          >
            投递线索
          </a>
        </div>
      )}
    </header>
  );
}